export class Template {
  id: number;
  title: string;
  content: string;
  sort_number: number;
}
